var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"f-form",class:{ 'center-form': _vm.centerForm },attrs:{"method":"post","novalidate":""},on:{"submit":_vm.onSubmit,"change":_vm.onChange,"input":_vm.onInput}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }